import { createFileRoute, notFound } from "@tanstack/react-router";
import RatgeberDetailPage from "@/pages/RatgeberDetailPage";
import NotFound from "@/pages/NotFound";
import { buildRouteHead } from "@/lib/route-head";
import { insights } from "@/data/insights";
import {
  articleSchema,
  breadcrumbSchema,
  faqSchema,
} from "@/lib/schema";

export const Route = createFileRoute("/ratgeber/$slug")({
  // Ohne echten 404-Status werten Google & Co. unbekannte Slugs als Soft-404.
  loader: ({ params }) => {
    if (!insights.some((i) => i.slug === params.slug)) {
      throw notFound();
    }
  },
  notFoundComponent: NotFound,
  head: ({ params }) => {
    const insight = insights.find((i) => i.slug === params.slug);
    if (!insight) {
      return buildRouteHead({
        title: "Ratgeber-Artikel nicht gefunden | Enno & Jens",
        description: "Dieser Artikel existiert nicht. Zur Übersicht aller Ratgeber-Beiträge.",
        path: `/ratgeber/${params.slug}`,
        noIndex: true,
      });
    }
    const path = `/ratgeber/${insight.slug}`;
    const image = `${insight.heroImage}-1024.webp`;
    const faqBlock = insight.contentBlocks?.find(
      (b): b is Extract<typeof b, { type: "faq" }> => b.type === "faq",
    );
    const scripts = [
      articleSchema({
        headline: insight.title,
        description: insight.seoDescription ?? insight.excerpt,
        path,
        image,
        datePublished: insight.datePublished,
        dateModified: insight.dateModified,
        authorName: insight.author.name,
        authorTitle: insight.author.title,
        articleSection: insight.category,
        keywords: insight.tags,
      }),
      breadcrumbSchema([
        { name: "Startseite", path: "/" },
        { name: "Ratgeber", path: "/ratgeber" },
        { name: insight.title, path },
      ]),
      ...(faqBlock && faqBlock.items.length ? [faqSchema(faqBlock.items)] : []),
    ];
    return buildRouteHead({
      title: insight.seoTitle
        ? `${insight.seoTitle} | Enno & Jens`
        : `${insight.title} | Ratgeber Enno & Jens`,
      description: insight.seoDescription ?? insight.excerpt,
      path,
      image,
      imageAlt: insight.heroImageAlt,
      imageWidth: 1024,
      imageHeight: 730,
      ogType: "article",
      scripts,
    });
  },
  component: RatgeberDetailPage,
});
